'use strict';

module.exports = {
  template: require('./cn-pdf-export.html'),
  controller: require('./cn-pdf-export.controller.js'),
  controllerAs: 'vm'
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-pdf-export/index.js
 ** module id = 53
 ** module chunks = 0
 **/